export default __webpack_public_path__ + "static/our-community-6f7d761e2d09910dc1bcf6fd46beaa47.webm";